/**
 * EventsBadge Constants
 */

import {
  CHANNEL,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import type { SoftphoneEvent } from 'Modules/softphone/services/EventService';

export const EVENT_BADGE_STYLES: Record<SoftphoneEvent['type'], string> = {
  SIP: CHANNEL.SIP,
  RTP: CHANNEL.RTP,
  DEVICE: CHANNEL.DEVICE,
  CALL: CHANNEL.CALL,
};
